import { createDom, hasClass } from 'xgplayer/src/utils/util'
import RequestFullIcon from '../assets/requestCssFull.svg'
import ExitCSSFullIcon from '../assets/exitCssFull.svg'
import '../style/controls/cssfullscreen.scss'

let s_cssFullscreen = function() {
  let player = this
  if (!player.config.cssFullscreen) {
    return
  }
  let btn = createDom(
    'xg-cssfullscreen',
    `<xg-icon class="xgplayer-icon">
        <div class="xgplayer-icon-requestfull full-icon">${RequestFullIcon}</div>
         <div class="xgplayer-icon-exitfull full-icon">${ExitCSSFullIcon}</div>
     </xg-icon>`,
    {},
    'xgplayer-cssfullscreen'
  )

  let tipsText = {}
  tipsText.requestfull = player.lang.CSSFULLSCREEN_TIPS
  tipsText.exitfull = player.lang.EXITFULLSCREEN_TIPS
  let tips = createDom(
    'xg-tips',
    `<span class="xgplayer-tip-requestfull">${tipsText.requestfull}</span>
                                        <span class="xgplayer-tip-exitfull">${tipsText.exitfull}</span>`,
    {},
    'xgplayer-tips tips-with-corn'
  )
  btn.appendChild(tips)
  player.once('ready', () => {
    player.controls.appendChild(btn)
  })
  ;['click', 'touchend'].forEach(item => {
    btn.addEventListener(item, function(e) {
      e.preventDefault()
      e.stopPropagation()
      // 如果有这个class，再发送beforeCssFullscreenEnter，会把clientHeight赋给视频高度，达到页面内全屏
      if (!hasClass(player.root, 'xgplayer-is-cssfullscreen')) {
        player.emit('beforeCssFullscreenEnter')
      }
      player.userGestureTrigEvent('cssFullscreenBtnClick')
    })
  })
}

export default {
  name: 's_cssFullscreen',
  method: s_cssFullscreen
}
